import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { DnsDetailsPage } from 'src/app/modals/domains/dns-details/dns-details.page';
import { ForwardingPage } from 'src/app/modals/domains/forwarding/forwarding.page';
import { DnsNameServerDto } from 'src/app/models/dns-nameservers.model';
import { GeneralService } from 'src/app/services/general.service';
import { domainUrl } from 'src/environments/environment';

@Component({
  selector: 'app-manage-domain',
  templateUrl: './manage-domain.page.html',
  styleUrls: ['./manage-domain.page.scss'],
})
export class ManageDomainPage implements OnInit {

  id = ''

  isLoading = false;

  isSelectAll = false

  dns = []
  domainForwarding = []
  subDomainForwarding = []
  validator = {}
  domain = ''

  nameServerDetails: any = {}
  tempNameServerDetails: any = {}
  redirectRulesetId = ''
  currentPage = 0
  totalPage = 0
  totalItems = 0
  isDefaultActive = true
  isEditingCustomNameservers = false

  // , 'Hostnames', 'SSL Certificate'

  tabs: string[] = ['DNS Records', 'Forwarding', 'Nameservers'];
  activeTab: string = 'DNS Records'; // default active tab


  dnsCols = [
    { field: 'name', header: 'Name' },
    { field: 'type', header: 'Type' },
    { field: 'ttl', header: 'TTL' },
    { field: 'content', header: 'Content' },
    { field: 'action', header: 'Action' }
  ];

  forwardingCols = [
    { field: 'Domain', header: 'Domain' },
    { field: 'Destination', header: 'Destination' },
    { field: 'Type', header: 'Type' },
    { field: 'action', header: 'Action' }
  ]

  subforwardingCols = [
    { field: 'Subdomain', header: 'Subdomain' },
    { field: 'Destination', header: 'Destination' },
    { field: 'Type', header: 'Type' },
    { field: 'action', header: 'Action' }
  ]

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private modalCtrl: ModalController,
    private generalService: GeneralService,
    private navCtrl: NavController
  ) {
    this.id = this.route.snapshot.queryParamMap.get('id');


  }

  async ngOnInit() {
    this.currentPage = 0

    this.isLoading = true
    this.loadNameServerStatus()
    this.getDnsRecords()
    // this.getForwarding()
    // DNS Records // Forwarding // Nameservers // Hostnames // DNSSEC
  }

  setActive(tab: string): void {

    if (this.activeTab === tab) {
      return
    }

    this.isLoading = true
    this.activeTab = tab;

    if (this.activeTab === 'DNS Records') {
      this.getDnsRecords()
    } else if (this.activeTab === 'Forwarding') {
      this.getForwarding()
    } else if (this.activeTab === 'Nameservers') {
      this.getNameServers()
    } else if (this.activeTab === 'Hostnames') {
      this.getDnsRecords()
    } else if (this.activeTab === 'SSL Certificate') {
      this.getDnsRecords()
    }

  }

  async getDnsRecords() {
    let response = await firstValueFrom(
      this.http.get(`${domainUrl}/get-dns-list?id=${this.id}&page=${this.currentPage}`)
    );

    this.isLoading = false

    console.log(response)

    this.domain = response['domain']

    if (response['status'] === 'SUCCESS') {
      this.dns = response['dns']
      this.totalPage = response['total_page']
      this.totalItems = response['total']
    }

    console.log(this.dns, 'DNS Records')
  }

  async getForwarding() {
    let response = await firstValueFrom(
      this.http.get(`${domainUrl}/get-forwardings?id=${this.id}`)
    );

    console.log(response)
    console.log('forwarding')

    this.domain = response['domain']

    this.isLoading = false

    if (response['status'] === 'SUCCESS') {
      this.redirectRulesetId = response['redirectRulesetId']
      this.subDomainForwarding = response['subDomainForwarding']
      this.domainForwarding = response['domainForwarding']
    }

    console.log(this.subDomainForwarding)

    console.log(response, 'DNS Records')
  }

  async getNameServers() {
    await this.loadNameServerStatus()
    this.isLoading = false
  }

  async loadNameServerStatus() {
    let response = await firstValueFrom(
      this.http.get(`${domainUrl}/get-nameserver?id=${this.id}`)
    );

    console.log(response, 'NameServers')

    if (response['status'] === 'SUCCESS') {
      this.nameServerDetails = response['details']
      this.tempNameServerDetails = JSON.parse(JSON.stringify(this.nameServerDetails))
      this.isEditingCustomNameservers = false
    }
  }


  removeNameserver(index) {
    this.tempNameServerDetails['nameservers'].splice(index, 1)
  }

  async deleteForwarding(ruleId, subdomain) {
    const result = await this.generalService.showConfirmButton({ title: 'Confirmation', description: 'Do you want to delete these records?' });
    if (result === 'Confirm') {

      this.generalService.pleaseWait('Please wait...', 'We are deleting your records.')

      let response = await firstValueFrom(
        this.http.delete(`${domainUrl}/delete-forwardings?id=${this.id}&redirectRulesetId=${this.redirectRulesetId}&ruleId=${ruleId}&subdomain=${subdomain}`)
      );

      this.generalService.swalClose()

      if (response['status'] === 'SUCCESS') {
        this.isLoading = true
        this.generalService.showToast('Deleted successfully', 'success', 'top')
        this.getForwarding()
      } else {
        this.generalService.showToast(response['message'], 'error', 'top')
      }


    }

  }

  selectAllDns() {
    this.isSelectAll = !this.isSelectAll

    if (this.isSelectAll) {
      this.dns = this.dns.map(x => ({ ...x, selected: true }))
    } else {
      this.dns = this.dns.map(x => ({ ...x, selected: false }))
    }
  }

  showDeleteDnsButton() {
    return this.dns.filter(x => x['selected'] === true).length
  }

  async deleteRecords(multiple, dnsId) {

    const result = await this.generalService.showConfirmButton({ title: 'Confirmation', description: 'Do you want to delete these records?' });
    if (result === 'Confirm') {

      this.generalService.pleaseWait('Please wait...', 'We are deleting your records.')


      let response = await firstValueFrom(
        this.http.post(`${domainUrl}/batch-delete-dns`, {
          id: this.id,
          dns_ids: multiple === true ? this.dns.filter(c => c['selected'] === true).map(x => x['dns_id']) : [dnsId]
        })
      );

      this.generalService.swalClose()


      if (response['status'] === 'SUCCESS') {
        this.isLoading = true
        this.generalService.showToast('Deleted successfully', 'success', 'top')
        this.getDnsRecords()
      } else {
        this.generalService.showToast(response['message'], 'error', 'top')
      }
    }



  }

  async openDnsManagement(dns, dns_id, isCreate) {
    const dnsModal = await this.modalCtrl.create({
      cssClass: 'modalTransparent',
      component: DnsDetailsPage,
      backdropDismiss: true,
      componentProps: {
        isCreate: isCreate,
        details: dns,
        id: this.id,
        dns_id: dns_id
      }
    });

    dnsModal.onDidDismiss().then(async (res) => {
      console.log(res)
      if (res['data']) {
        this.isLoading = true;
        this.getDnsRecords()
      }
    })

    return await dnsModal.present();
  }

  async openForwardingManagement(details, isSubdomain) {

    console.log('hi')
    console.log(this.domain)
    const forwardingModal = await this.modalCtrl.create({
      cssClass: 'modalTransparent',
      component: ForwardingPage,
      backdropDismiss: true,
      componentProps: {
        id: this.id,
        redirectRulesetId: this.redirectRulesetId,
        details: details,
        isSubdomain: isSubdomain,
        domain: this.domain
      }
    });

    forwardingModal.onDidDismiss().then(async (res) => {
      console.log(res)
      if (res['data']) {
        this.isLoading = true;
        this.getForwarding()
      }
    })


    return await forwardingModal.present();

  }

  toggleDefault() {
    this.tempNameServerDetails['isDefault'] = !this.tempNameServerDetails['isDefault'];

    if (this.tempNameServerDetails['isDefault']) {
      this.isEditingCustomNameservers = false
    }
  }

  getCurrentNameserverTitle() {
    return this.tempNameServerDetails['isDefault'] ? 'Current Nameservers' : 'Current Nameserver';
  }

  hasDetectedCustomNameservers() {
    return this.tempNameServerDetails['isDefault'] === false
  }

  getExternalDnsWarningTitle() {
    return 'We detected that your nameservers have changed.'
  }

  getExternalDnsWarningMessage() {
    return 'This domain is using custom nameservers, so DNS records and forwarding are no longer managed here.'
  }

  getExternalDnsWarningAction() {
    return 'Please manage DNS records and forwarding directly with your current nameserver provider.'
  }

  showNameServerButton() {
    return this.nameServerDetails['isDefault'] === this.tempNameServerDetails['isDefault'] && JSON.stringify(this.nameServerDetails['nameservers']) === JSON.stringify(this.tempNameServerDetails['nameservers'])
  }

  shouldShowNameServerActions() {
    if (this.tempNameServerDetails['isDefault']) {
      return this.showNameServerButton() === false
    }

    return this.canEditCustomNameservers()
  }

  shouldShowNameServerSaveButton() {
    return this.showNameServerButton() === false
  }

  startEditingCustomNameservers() {
    this.tempNameServerDetails = JSON.parse(JSON.stringify(this.nameServerDetails))
    this.tempNameServerDetails['isDefault'] = false
    this.isEditingCustomNameservers = true
  }

  canEditCustomNameservers() {
    return this.tempNameServerDetails['isDefault'] === false && this.isEditingCustomNameservers
  }


  addNameserver() {
    this.tempNameServerDetails['nameservers'].push({
      name: ''
    })
  }

  handleNameServerCancel() {
    this.tempNameServerDetails = JSON.parse(JSON.stringify(this.nameServerDetails))
    this.isEditingCustomNameservers = false
  }

  async handleNameaServerSave() {

    let validateResult = await this.generalService.validateInput(this.tempNameServerDetails, DnsNameServerDto, [])


    if (validateResult['status'] === 'FAIL') {
      this.generalService.showToast('One of the nameserver is empty value!', 'error', 'top')
      this.validator = validateResult['result']
      return
    }
    

    this.validator = {}

    this.tempNameServerDetails = validateResult['correctData']

    this.generalService.pleaseWait('Please wait...', 'We are creating your dns record...')

    this.tempNameServerDetails['id'] = this.id

    let response = await firstValueFrom(
      this.http.put(`${domainUrl}/update-nameserver`, this.tempNameServerDetails)
    );

    this.generalService.swalClose()

    if (response['status'] === 'SUCCESS') {
      this.nameServerDetails = JSON.parse(JSON.stringify(this.tempNameServerDetails))
      this.isEditingCustomNameservers = false
      this.generalService.showToast('Created successfully', 'success', 'top')
      this.modalCtrl.dismiss(true)
    } else {
      this.generalService.showToast(response['message'], 'error', 'top')
    }

  }

  previousStep() {
    this.navCtrl.pop()
  }
}
